var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4549"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 618",
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_18746_11518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.534 7.04172C15.0708 7.67846 13.811 8.19729 12.8361 8.29162C13.278 7.10304 13.0425 5.2315 11.7759 4.23535C11.5415 4.46043 11.2335 4.72774 10.8812 5.03361L10.8811 5.03362C9.00352 6.66346 5.86456 9.38817 5.86456 12.6526C5.86456 16.1985 8.39287 18.6153 11.8399 18.6153C15.2869 18.6153 18.2202 16.3881 18.1301 12.7743C18.0807 10.7942 17.2589 8.60103 15.534 7.04172ZM13.6743 9.67956C12.7164 8.74907 11.1658 8.755 10.2172 9.69124C9.79317 10.1098 9.56038 10.6892 9.5793 11.2817C9.58981 11.6039 9.85144 11.856 10.1782 11.8616L10.2082 11.8621C10.5453 11.8521 10.8099 11.5757 10.8005 11.2457C10.7921 10.9764 10.8924 10.7236 11.0845 10.5341C11.5594 10.0655 12.3352 10.063 12.8141 10.5282C13.2006 10.9038 13.2032 11.5176 12.8198 11.8967C12.7802 11.9361 12.7376 11.9726 12.694 12.0052C11.8394 12.6474 11.3513 13.5993 11.356 14.6164C11.3575 14.9423 11.6259 15.2063 11.9567 15.2119L11.9697 15.2121C12.1326 15.2119 12.2857 15.149 12.4006 15.0354C12.5155 14.9219 12.578 14.7712 12.5777 14.6117C12.5746 13.9715 12.8888 13.367 13.4386 12.9545C13.5257 12.8895 13.6089 12.8175 13.6872 12.7395C14.5454 11.8928 14.5387 10.5204 13.6743 9.67956ZM12.6267 16.4358C12.6291 16.8005 12.3273 17.0981 11.9526 17.1005C11.578 17.1029 11.2724 16.8092 11.27 16.4445C11.2677 16.0798 11.5695 15.7823 11.9441 15.7799C12.3188 15.7774 12.6244 16.0711 12.6267 16.4358Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18746_11518",
    x1: 3.21518e-8,
    y1: 23.5496,
    x2: 29.7154,
    y2: 3.20497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D03673"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyIcon);
export default __webpack_public_path__ + "static/media/replyIcon.48fdfb20.svg";
export { ForwardRef as ReactComponent };